var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIntelligentgraphicIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u7F16\u7EC4 17") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M2,0 L8.53164557,0 C9.63621507,-2.02906125e-16 10.5316456,0.8954305 10.5316456,2 L10.5316456,13.3670886 L10.5316456,13.3670886 L2,13.3670886 C0.8954305,13.3670886 1.3527075e-16,12.4716581 0,11.3670886 L0,2 C-1.3527075e-16,0.8954305 0.8954305,-6.85272294e-16 2,0 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5207\\u56FE",
    transform: "translate(-325.000000, -6172.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-17",
    transform: "translate(325.000000, 6172.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#D8D8D8",
    opacity: 0,
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-31",
    transform: "translate(1.833333, 3.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-9"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "\\u77E9\\u5F62",
    fill: "#FE5454",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.69620253,3.78876582 C7.97234491,3.78876582 8.19620253,4.01262345 8.19620253,4.28876582 C8.19620253,4.53422571 8.01932737,4.73837419 7.78607816,4.78071015 L7.69620253,4.78876582 L5.26582278,4.78876582 C4.98968041,4.78876582 4.76582278,4.5649082 4.76582278,4.28876582 C4.76582278,4.04330593 4.94269795,3.83915745 5.17594715,3.79682149 L5.26582278,3.78876582 L7.69620253,3.78876582 Z",
    id: "\\u8DEF\\u5F84-38",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.46736551,3.78876582 C3.74350788,3.78876582 3.96736551,4.01262345 3.96736551,4.28876582 C3.96736551,4.53422571 3.79049035,4.73837419 3.55724114,4.78071015 L3.46736551,4.78876582 L3.11155063,4.78876582 C2.83540826,4.78876582 2.61155063,4.5649082 2.61155063,4.28876582 C2.61155063,4.04330593 2.78842579,3.83915745 3.021675,3.79682149 L3.11155063,3.78876582 L3.46736551,3.78876582 Z",
    id: "\\u8DEF\\u5F84-38",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.35719937,6.82674051 C5.63334174,6.82674051 5.85719937,7.05059813 5.85719937,7.32674051 C5.85719937,7.5722004 5.68032421,7.77634888 5.447075,7.81868484 L5.35719937,7.82674051 L3.0181962,7.82674051 C2.74205383,7.82674051 2.5181962,7.60288288 2.5181962,7.32674051 C2.5181962,7.08128062 2.69507136,6.87713214 2.92832057,6.83479618 L3.0181962,6.82674051 L5.35719937,6.82674051 Z",
    id: "\\u8DEF\\u5F84-38",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#FF9A4A",
    x: 6.48101266,
    y: 7.29113924,
    width: 9.51898734,
    height: 7.29113924,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.47259573,11.2996218 C9.45238374,10.3097278 11.0459906,10.2701321 12.1654623,11.2636991 L12.3029205,11.3932821 C13.170142,12.2605036 14.0371054,12.7200245 14.9085397,12.7945395 C15.183678,12.8180661 15.3876496,13.060182 15.3641229,13.3353203 C15.3405963,13.6104586 15.0984804,13.8144302 14.8233421,13.7909036 C13.6963067,13.6945325 12.6188875,13.1234627 11.5958137,12.1003888 C10.8303181,11.3348933 9.63812087,11.3348933 7.91980933,12.194049 C7.67282008,12.3175437 7.37248356,12.2174315 7.24898894,11.9704422 C7.12549431,11.723453 7.22560649,11.4231165 7.47259573,11.2996218 Z",
    id: "\\u8DEF\\u5F84-41",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "\\u692D\\u5706\\u5F62",
    fill: "#FFFFFF",
    cx: 13.4683544,
    cy: 9.68577811,
    r: 1
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntelligentgraphicIcon);
export default __webpack_public_path__ + "static/media/Intelligentgraphic_icon.6ae1f4a7674de4e44de95491f0178118.svg";
export { ForwardRef as ReactComponent };